import { IMarket } from '@/modules/neovehicle/models';

export class Market implements IMarket {
  private dateFormatter = new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'UTC',
  });

  private numberFormatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

  constructor(
    public readonly money: string = '0',
    public readonly date: string = '',
  ) {
    this.money = money;
    this.date = date.substring(0, 10);
  }

  public validate(): [boolean, string] {
    if (
      (this.getMoneyNumber() > 0 && this.date === '') ||
      (this.getMoneyNumber() === 0 && this.date !== '')
    ) {
      return [
        false,
        'Valor de Referência e Data Referência Valor são obrigatórios!',
      ];
    }

    return [true, ''];
  }

  public getDateISO() {
    if (this.date) {
      return new Date(this.date).toISOString();
    }

    return '';
  }

  public getDateFormatted() {
    if (this.date) {
      return this.dateFormatter.format(new Date(this.date));
    }

    return '-';
  }

  public getMoneyFormatted() {
    if (this.money) {
      return this.numberFormatter.format(this.getMoneyNumber());
    }

    return '';
  }

  public getMoneyNumber() {
    return Number(
      this.money
        .replace('R$ ', '')
        .replace(/\./gi, '')
        .replace(/,/gi, '.'),
    );
  }
}
